import { Reseller } from '@ViewModels';
import * as React from 'react';
import { ECompactLogoIconType } from '../CompactLogoIcon';
import { getCompactLogoComponent } from '../utils/resellerLogoResolver';

interface IProps {
	className?: string;
	height?: number;
	loading?: boolean;
	width?: number;
	type?: ECompactLogoIconType;
	/**
	 * The reseller type to determine which logo to display.
	 * If not provided, defaults to Levitate compact logo.
	 */
	reseller?: Reseller;
}

/**
 * Dynamic compact logo component that renders the appropriate compact logo based on reseller.
 * This component provides indirection for logo selection.
 *
 * @example
 * // Default Levitate compact logo
 * <ResellerCompactLogoIcon />
 *
 * @example
 * // Cambridge compact logo
 * <ResellerCompactLogoIcon reseller={Reseller.Cambridge} />
 *
 * @example
 * // Loading state
 * <ResellerCompactLogoIcon loading reseller={account.reseller} />
 */
export const ResellerCompactLogoIcon: React.FC<IProps> = ({ reseller, ...props }) => {
	const CompactLogoComponent = getCompactLogoComponent(reseller);
	return <CompactLogoComponent {...props} />;
};
